//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isXylemSSO } from '@/config';
import { Features, isEnabled } from '@/config/features';
import Security from '@/config/security';

export default {
  name: 'SectionNavigation',
  props: {
    state: { type: Object, default: () => ({}) },
  },
  computed: {
    sections() {
      const routes = [
        {
          name: 'Dashboard',
          icon: 'dashboard-nav',
          routeName: 'dashboard',
          visible: !isEnabled(Features.SCALE_MODE) && Security.canRead('dashboard'),
        },
        {
          name: 'Cohort',
          icon: 'cohort-nav',
          routeName: 'cohort',
          visible: !isEnabled(Features.SCALE_MODE) && Security.canRead('kpis'),
        },
        {
          name: 'View',
          icon: 'view-nav',
          routeName: 'view',
          visible: !isEnabled(Features.SCALE_MODE) && Security.canRead('view'),
        },
        {
          name: 'Incidents',
          icon: 'incident',
          routeName: 'incidents',
        },
        {
          name: 'Connect',
          icon: 'connect-nav',
          visible: !isEnabled(Features.SCALE_MODE) && Security.canRead('connect'),
          routeName: 'connections',
        },
        {
          name: 'Settings',
          icon: 'settings-nav',
          visible: Security.canRead('settings'),
          children: [
            {
              name: 'User settings',
              routeName: 'userSettings',
              icon: 'user',
              visible: Security.canRead('user'),
            },
            {
              name: 'Manage users',
              routeName: 'manageUsers',
              icon: 'settings',
              visible: !isXylemSSO() && Security.canRead('manageUsers'),
            },
            {
              name: 'Filters',
              routeName: 'manageFilters',
              icon: 'filter',
              visible: !isEnabled(Features.SCALE_MODE) && Security.canRead('filters'),
            },
            {
              name: 'KPIs',
              routeName: 'manageKpis',
              icon: 'bar-chart',
              visible: !isEnabled(Features.SCALE_MODE) && Security.canRead('kpis'),
            },
            {
              name: 'Dashboards',
              routeName: 'manageDashboards',
              icon: 'dashboard',
              visible: !isEnabled(Features.SCALE_MODE) && Security.canRead('dashboard'),
            },
            {
              name: 'Properties',
              routeName: 'properties',
              icon: 'metadata',
              visible: Security.canRead('connect'),
            },
            {
              name: 'Branding',
              routeName: 'branding',
              icon: 'paintbrush',
              visible: Security.canRead('branding'),
            },
            {
              name: 'Tokens',
              routeName: 'tokens',
              icon: 'key',
              visible: Security.canRead('tokens'),
            },
            {
              name: 'Delete data',
              routeName: 'delete',
              icon: 'delete',
              visible: Security.canWrite('delete'),
            },
          ],
        },
      ];

      return routes;
    },
  },
  methods: {
    toggleSection(section) {
      if (!section.children) {
        return;
      }

      const { name } = section;
      const state = { ...this.state };

      if (!state[name] || state?.[name].open === undefined) {
        state[name] = { open: true };
      } else {
        state[name].open = !state[name].open;
      }
      this.$emit('update-state', state);
    },
  },
};
